import EleTable from './ele-table.vue';

export default EleTable;